<section class="relative md:py-16 py-8">
  <div class="container">
      <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">

        <div class="group relative overflow-hidden bg-earth-try rounded-md shadow p-8">
          <h3 class="text-xl text-earth-xdark mb-4 ">Vormingen binnen MUDICO</h3>
          We proberen binnen MUDICO voldoende in te zetten op vorming van ouders, leerkrachten en collega's om zo de ondersteuning van kinderen te maximaliseren waar mogelijk. Neem een kijkje en kom gerust eens langs op één van onze vormingen en sessies!
        </div>

        <div *ngFor="let v of vormingen" class="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700">
              <div class="relative overflow-hidden">
                <a [routerLink]="['/vorming']" [queryParams]="{vorming: v.id}">
                  <img [src]="v.foto" class="scale-110 group-hover:scale-100 transition-all duration-500" alt="">
                </a>
              </div>

              <div class="relative p-6">
                  <div class="absolute left-6 -top-4">
                      <span class="bg-earth-try text-black/70 text-[12px] px-2.5 py-1 font-semibold rounded-full h-5">{{v.type}}</span>
                  </div>

                  <div class="">
                      <div class="flex mb-4">
                          <span class="text-slate-400 text-sm"><i class="uil uil-calendar-alt text-slate-900 dark:text-white mr-2"></i>{{v.date}}</span>
                          <span class="text-slate-400 text-sm ml-4"><i class="uil uil-clock text-slate-900 dark:text-white mr-2"></i>{{v.hour}}</span>
                      </div>

                      <a [routerLink]="['/vorming']" [queryParams]="{vorming: v.id}" class="title text-lg font-semibold hover:text-earth-xdark duration-500 ease-in-out">{{v.titel}}</a>

                      <div class="flex justify-between items-center mt-3">
                        <span class="text-slate-400 text-sm">door {{v.organisator}}</span>
                        <a [routerLink]="['/vorming']" [queryParams]="{vorming: v.id}" routerLinkActive="router-link-active" class="btn btn-link hover:text-earth-xdark after:bg-earth-xdark duration-500 ease-in-out">Meer info <i class="uil uil-arrow-right"></i></a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</section>
